"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryToJSON = exports.DeliveryFromJSONTyped = exports.DeliveryFromJSON = exports.Delivery = void 0;
/**
 * Toggles the delivery of the entity ON or OFF.
 * @export
 */
exports.Delivery = {
    On: 'ON',
    Off: 'OFF'
};
function DeliveryFromJSON(json) {
    return DeliveryFromJSONTyped(json, false);
}
exports.DeliveryFromJSON = DeliveryFromJSON;
function DeliveryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DeliveryFromJSONTyped = DeliveryFromJSONTyped;
function DeliveryToJSON(value) {
    return value;
}
exports.DeliveryToJSON = DeliveryToJSON;
